import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import PageLoader from "../../../../../../../../components/PageLoader";
import { useAppDispatch } from "../../../../../../../../hooks/hooks";
import storePersist from "../../../../../../../../redux/storePersist";
import { ManagementGatewayLogMessage } from "./gateway-log-item-popup";
import { selectGatewayLogsListItems } from "../../../../../../../../redux/gateway-logs/selector";
import { gatewayLogs } from "../../../../../../../../redux/gateway-logs/action";
import Table from "../../../../../../../../common/components/table";


const ManagementGatewayLogs = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
  const [showMessageDetailsPopup, setShowMessageDetailsPopup] = useState<boolean>(false);
  const [selectedMessage, setSelectedMessage] = useState<boolean>(false);
   var tenantId = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.TenantId;
    const itemsData = useSelector(selectGatewayLogsListItems)
    console.log(itemsData,'itemsData')
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Message', headerName: 'Message',searchField: 'Message', filter: true,
            filterType: 'text', callback: showMessageDetails},
          { field: 'Level', headerName: 'Level',searchField: 'Level', filter: true,
            filterType: 'text'},
          { field: 'Metadata.timestamp', headerName: 'Metadata' },
          { field: 'timestamp', headerName: 'Timestamp', isDateValueFormat: true, sortable: false },
        ]);
      }

      const showMessageDetails = async (data: any) => {
        console.log('data', data)
        setSelectedMessage(data?.Message)
        setShowMessageDetailsPopup(true)
      }

      const closeModal = () => {
        setSelectedMessage(null)
        setShowMessageDetailsPopup(false)
      }

      const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column){
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        }
            
        dispatch(gatewayLogs.list({url:`https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/log-management/gateway-logs`,entity:'cards',jsonData:{
          
            "Context": {},
            "Records": [ {
              "TenantId": tenantId
            }],
            "Pagination": {
              "PageNumber": pageData,
              "PageSize": pageSize,
              "SortField": "timestamp",
              "SortOrder": "desc",
            },
          }}))
      }
      const handleReloadData = () => {
        dispatch(gatewayLogs.list({url:`https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/log-management/gateway-logs`,entity:'cards',jsonData:{
          "Context": {},
          "Records": [ {
            "TenantId": tenantId
          }],
          "Pagination": {
            "PageNumber": pageData,
            "PageSize": pageSize,
            "SortField": "timestamp",
            "SortOrder": "desc",
          },
      
          }}))
      }
      const additionButtons: any = [
        
           {
             svg:
             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
             <title>Reload</title>
             <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
           </svg>,
           // name: 'Reload',
           callback: () => handleReloadData(),
           },
      ];
      const fetchGatewayLogs=()=>{
        dispatch(gatewayLogs.list({url:`https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/log-management/gateway-logs`,entity:'gatewayLogs',jsonData:{
          "Context": {},
          "Records": [ {
            "TenantId": tenantId
          }],
          "Pagination": {
            "PageNumber": pageData,
            "PageSize": pageSize,
            "SortField": "timestamp",
            "SortOrder": "desc",
          },
        
    
        }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchGatewayLogs()
	}, [pageData,pageSize])

  return (
    <>
      {showMessageDetailsPopup ? <ManagementGatewayLogMessage item={selectedMessage} closeModal={closeModal}/> : <></>}
      {itemsData?.isLoading ? <PageLoader />
        :
        <Table 
          enableFilter={true}
          onSearch={handleSearch} 
          columnData={columnDefs} 
          rowData={itemsData?.result?.items} 
          setPageData={setPageData} 
          setPageSize={setPageSize}
          paginationData={itemsData?.result?.pagination} 
          additionButtons={additionButtons} 
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
          }}
          headingName="Gateway logs" 
        />

      }
    </>
  );
};

export default ManagementGatewayLogs;


